import _ from 'lodash';
import { generateActionCreators } from '../../utils/connectors';
/**
 * Maps entity item from redux to props for react-redux @connect
 * @param  {Object} model [description]
 * @param  {string|Function} id
 * @param  {Object} state
 * @param  {Object} props
 * @param  {Object} fields
 * @return {Function}
 */

export function mapEntityState(model, id, state, props, fields) {
  var itemId = _.isFunction(id) ? id(props) : id;
  return model.selectors(state, props, {
    itemId: itemId,
    fields: fields
  });
}
/**
 * Maps entity list from redux to props
 * @param  {Object} model
 * @param  {string|Function} id
 * @param  {Object} state
 * @param  {Object} props
 * @param  {Object} fields
 * @return {Function}
 */

export function mapEntityListState(model, id, state, props, fields) {
  var listId = _.isFunction(id) ? id(props) : id;
  return model.selectors(state, props, {
    listId: listId,
    fields: fields
  });
}
/**
 * Maps action creators to props for react-redux @connect
 * @param  {Object} model
 * @param  {Function} dispatch
 * @return {Function}
 */

export function mapEntityDispatch(model, dispatch) {
  return generateActionCreators(model)(dispatch);
}